export default {
  productList: [],
  loadingProducts: false,
  groups: [],
  totalGroups: 0,
  loadingGroups: false,
  productSearch: {
    query: null,
    loading: false,
    items: [],
    selected: [],
  },
};
